export const readLocalStorageValue = <T>(key: string, fallback: T, parse: (value: string) => T): T => {
    try {
        const storedValue = localStorage.getItem(key)
        return storedValue === null ? fallback : parse(storedValue)
    } catch {
        return fallback
    }
}

export const writeLocalStorageValue = (key: string, value: string): void => {
    try {
        localStorage.setItem(key, value)
    } catch {
        // Storage can be unavailable in private mode or when the browser quota is exhausted.
    }
}
